function Terms() {
  return (
    <div>      
      <h1 className="py-16 font-semibold">Termo de Consentimento Livre e Esclarecido para Usuários da Plataforma Web</h1>
      <p style={{marginBottom: '10px'}}>
        Prezado(a) Usuário(a),
      </p>      
      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        Você está sendo convidado(a) a participar da pesquisa intitulada: 
        "Uma Plataforma Tecnológica de Apoio ao Planejamento do Ensino, Avaliação e Prática Docente no Âmbito da EPT: 
        Integrando a Taxonomia de Bloom Revisada". Esta pesquisa, sob a responsabilidade do pesquisador Edilton Costa Alves, 
        Documento de Identidade nº 3406732 SSP/GO, estudante do Programa de Mestrado Profissional em 
        Educação Profissional e Tecnológica – ProfEPT do Instituto Federal de Brasília - IFB, 
        orientado pela professora Dra. Daniele dos Santos Roda, visa aprimorar a prática docente na Educação Profissional 
        e Tecnológica (EPT) através da plataforma web que você está prestes a utilizar.
      </p>
      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Objetivos da Pesquisa:</p>
        <p>O principal objetivo é desenvolver e aprimorar a plataforma web que auxilia educadores a elaborar objetivos de aprendizagem claros, mensuráveis e alinhados aos níveis de complexidade cognitiva propostos pela Taxonomia de Bloom Revisada.</p>
      </p>
      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Procedimentos de Pesquisa:</p>
        <p>Como participante, pode-se solicitar que você forneça feedback, responda questionários ou participe de testes que contribuirão para o aprimoramento da plataforma. Todas essas atividades são voluntárias.</p>
      </p>
      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Confidencialidade:</p>
        <p>Os dados coletados serão mantidos sob a guarda do pesquisador responsável e usados exclusivamente para fins de pesquisa.</p>      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Voluntariedade:</p>
        <p>Sua participação é inteiramente voluntária, sem remuneração. Você tem o direito de recusar-se a participar ou de retirar seu consentimento e descontinuar a participação a qualquer momento sem penalidades.</p>        
      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Devolução dos Resultados:</p>
        <p>Os resultados da pesquisa serão compartilhados com os participantes e a comunidade acadêmica por meio de uma dissertação de mestrado.</p>
      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Contato:</p>
        <p>Em caso de dúvidas, entre em contato com o pesquisador responsável através do telefone (61) 9 8188-5287 ou e-mail edilton.costa@gmail.com.</p>
      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Aprovação Ética:</p>
        <p>Este projeto foi cadastrado na Plataforma Brasil e aprovado pelo Sistema CEP/CONEP: Conselho de Ética e Pesquisa – CEP e Comissão Nacional de Ética em Pesquisa – CONEP, e encaminhado ao Comitê de Ética em Pesquisa do Centro Universitário de Brasília – UniCEUB (CEP-UniCEUB), conforme registro nº __, na data: //.</p>
      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Consentimento Online:</p>
        <p>Este TCLE é apresentado a você de forma digital, antes do acesso à plataforma web. Ao selecionar a opção de consentimento abaixo, você estará concordando com os termos aqui descritos.</p>
      </p>

      <p style={{marginBottom: '10px', textAlign: 'justify'}}>
        <p>Por favor, indique a sua escolha:</p>
        <p>
          Confirmo ter lido o Termo de Consentimento Livre e Esclarecido e aceito participar da pesquisa e utilizar a plataforma web.
        </p>
        <p>
          Discordo e não aceito participar da pesquisa nem utilizar a plataforma web.
        </p>
      </p>
      
    </div>
  );
}

export default Terms;
